import { IconGroup, StatusWidgetMessage } from '../Types/Notifications.types';
import { AppDispatch } from '../../app/store';
import { fetchNotificationsByJobid, setNewNotification } from '../Slices/Notifications.slice';
import { setStatusUpdateNotificationStatusWidgetState } from '../../component/status-widget/statusWidget.slice';
import { GetStatusWidgetEventMessage } from '../../Constants/StatusWidgetMessages';
import { showErrorSnackbar, showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';
import { EventType } from '../../component/status-widget/types/Event.types';

export function addClientStatusWidgetNotification(
    statusWidgetMessage: StatusWidgetMessage,
    dispatch: AppDispatch,
    userManager: any,
) {
    const isSameUser = userManager.user?.profile?.preferred_username.toLowerCase() === statusWidgetMessage.reviewedByEmail.toLowerCase();
    const message = GetStatusWidgetEventMessage(statusWidgetMessage.eventType);
    dispatch(setStatusUpdateNotificationStatusWidgetState(statusWidgetMessage));
    if ((statusWidgetMessage.eventType === EventType.JobLockFinalizedFail
        || statusWidgetMessage.eventType === EventType.JobUnlockFail) && isSameUser) {
            showErrorSnackbar(dispatch, message);
        return;
    }
    isSameUser && showSuccessSnackbar(dispatch, message);
    dispatch(fetchNotificationsByJobid(statusWidgetMessage.groupId));
    dispatch(setNewNotification());
}

export function addUserStatusWidgetNotification(
    statusWidgetMessage: StatusWidgetMessage,
    dispatch: AppDispatch,
) {
    dispatch(setStatusUpdateNotificationStatusWidgetState(statusWidgetMessage));
    dispatch(fetchNotificationsByJobid(statusWidgetMessage.groupId));
    dispatch(setNewNotification());
}